import type { ReactNode } from 'react';

export const symbol_grid_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M340-180v-160H180v160h160Zm220 0v-134l-26-26H400v160h160Zm60 0Zm86-160Zm-366-60v-134l-26-26H180v160h160Zm60 0Zm380 0v-160H620v134l26 26h134ZM486-560Zm-306-60Zm380 0v-160H400v134l26 26h134Zm220 0v-160H620v160h160ZM266-780Zm574 574L206-840h574q24 0 42 18t18 42v574Zm-660 86q-24 0-42-18t-18-42v-660l720 720H180Zm632 57L47-827q-9-9-8.5-21.5T48-870q9-9 21.5-9t21.5 9l764 765q9 9 9 21t-9 21.39Q846-54 833.5-54T812-63Z"
		/>
	</svg>
);
